<template>
    <div>
        <div v-if="userDetails">
            <b-card no-body>
                <b-tabs card>
                    <b-tab title="Details">
                        <simple-display-grid key="userDetails"
                                             :columnCount="1"
                                             :inputs="userDetailsInputs"
                                             :values="userDetails" />
                        <hr />
                        <data-list-pagination v-if="userOtherClaims"
                                              :dataCols="otherClaimsCols"
                                              :dataListItems="userOtherClaims"
                                              :tableClass="'table table-striped table-sm'"
                                              @pagination-input="() => {}" />

                    </b-tab>
                    <b-tab title="Login History">
                        <data-list-pagination v-if="userLoginHistory"
                                              :dataCols="loginCols"
                                              :dataListItems="userLoginHistory"
                                              :tableClass="'table table-striped table-sm'"
                                              @pagination-input="handlePaginationInput" />
                    </b-tab>
                    <b-tab title="JSON">
                        <json-viewer v-model="userDetails"
                                     :viewMode="0" />
                        <json-viewer v-if="userLoginHistory"
                                     v-model="userLoginHistory"
                                     :viewMode="0" />
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
        <div v-else>
            <p v-if="!policyImported"><i class="fas fa-info-circle mr-2"></i>NO POLICY HAS BEEN IMPORTED FOR THIS CLAIM!</p>

            <div v-if="selectedClaim && policyImported">
                <div v-if="webUserExists">
                    <p>
                        <i class="fas fa-info-circle mr-2"></i>It looks like a user acount exists for the
                        email {{claimantEmailAddress}} and reseller {{resellerName}}.  Check the previous
                        claims before assigning this claim to the user account.
                    </p>

                    <simple-display-grid key="userDetails"
                                         :columnCount="1"
                                         :inputs="userDetailsInputs"
                                         :values="webUserDetails" />
                    <hr />
                    <data-list-pagination v-if="webUserClaims"
                                          :dataCols="otherClaimsCols"
                                          :dataListItems="webUserClaims"
                                          :tableClass="'table table-striped table-sm'"
                                          @pagination-input="() => {}" />

                    <button class="btn btn-primary" @click="handleUserAssignClick">Assign claim to user</button>
                </div>
                <div v-else>
                    <p>
                        <i class="fas fa-info-circle mr-2"></i>It looks like a user acount does not exists for the
                        email {{claimantEmailAddress}} and reseller {{resellerName}}.
                    </p>
                    <button class="btn btn-primary" @click="handleUserCreateAssignClick">Create / assign the user</button>
                </div>
            </div>  
        </div>
    </div>
</template>

<script>

    import { mapActions, mapGetters  } from 'vuex'

    import JsonViewer from '@/components/jsonViewer.vue'
    import SimpleDisplayGrid from '@/components/SimpleDisplayGrid.vue'
    import DataListPagination from '@/components/DataListPagination.vue'

    export default {
        name: 'ClaimUser',
            props: {
                userId: { type: String, required: false }
            },
            mixins: [
            
            ],
        components: {
            'json-viewer': JsonViewer,
            SimpleDisplayGrid,
            DataListPagination
        },
        data: () => {
            return {
                userDetailsInputs: [
                    {
                        id: 'emailAddress',
                        label: 'Email Address',
                        type: 'text',
                        placeholder: 'Email Address',
                        dataPath: 'emailAddress'
                    },
                    {
                        id: 'lastSignedInDateAsLocalTime',
                        label: 'Last Sign-in',
                        type: 'text',
                        placeholder: 'Last Sign-in',
                        dataPath: 'lastSignedInDateAsLocalTime'
                    },
                    {
                        id: 'dateCreatedAsLocalTime',
                        label: 'Date created',
                        type: 'text',
                        placeholder: 'Date created',
                        dataPath: 'dateCreatedAsLocalTime'
                    }
                ],
                loginCols: [
                    {
                        key: 'attemptDateAsLocalTime',
                        display: 'Attempt Date'
                    },
                    {
                        key: 'originatingIP',
                        display: 'IP'
                    },
                    {
                        key: 'successful',
                        display: 'Success'
                    }
                ],

                otherClaimsCols: [
                    {
                        key: 'claimReference',
                        display: 'Claim Reference'
                    },
                    {
                        key: 'policyNumber',
                        display: 'Policy Number'
                    },
                    {
                        key: 'claimantFullname',
                        display: 'Claimant Fullname'
                    },
                    {
                        key: 'claimantEmail',
                        display: 'Claimant Email'
                    }
                ],

                pageNumber: 1,
                pageSize: 10
            }
        },
        computed: {
            ...mapGetters({
                policyDetails: 'selectedClaimPolicyDetails',
                policyImported: 'selectedClaimPolicyImported',
                webUserExists: 'formUser/userExists',
                webUserDetails: 'formUser/webUser',
                webUserClaims: 'formUser/webUserClaims'
            }),
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            resellerId() { return this.selectedClaim.resellerId },
            resellerName() { return this.selectedClaim.resellerName },
            claimantEmailAddress() { return this.selectedClaim.claimantDetails.email },
            userDetails() {
                return this.selectedClaim.userDetails
            },
            userLoginHistory() {
                return this.selectedClaim.userLoginHistory
            },
            userOtherClaims() {
                let { userDetails } = this.selectedClaim
                if (userDetails) {
                    return userDetails.webUserClaims
                }

                return null
            },
        },
        mounted() {
            let { userId, pageNumber } = this
            
            if (userId) {
                this.fetchUserClaim({ userId })
                this.fetchUserLoginHistoryClaim({ userId, pageNumber })
            } else {
                if (this.policyImported) {
                    
                    let { resellerId, claimantEmailAddress } = this
                    this.checkUserExists({ resellerId, emailAddress: claimantEmailAddress })
                }
            }
        },
        methods: {
            ...mapActions({
                fetchUserClaim: 'fetchUserClaim',
                fetchUserLoginHistoryClaim: 'fetchUserLoginHistoryClaim',
                checkUserExists: 'formUser/checkUserExists',
                createUser: 'formUser/createUser',
                assignUserToClaim: 'formUser/assignUserToClaim',
                //createAssignUserToClaim: 'formUser/createAssignUserToClaim',
                createAssignUserToClaim: 'formUser/createAssignUserToClaimAsync'
            }),
            handleUserExistsClick() {
                let { resellerId, claimantEmailAddress } = this
                this.checkUserExists({ resellerId, emailAddress: claimantEmailAddress})
            },
            handleUserCreateClick() {
                let { resellerId, claimantEmailAddress } = this
                this.createUser({ resellerId, emailAddress: claimantEmailAddress })
            },
            handleUserAssignClick() {
                let { id } = this.$store.state.formUser.webUser
                let { claimId, claimRowVersion } = this.selectedClaim

                this.assignUserToClaim({ webUserId: id, claimId, rowVersion: claimRowVersion })
                
                this.fetchUserLoginHistoryClaim({ userId: id, pageNumber: 1 })

            },
            async handleUserCreateAssignClick() {
                let { resellerId, claimantEmailAddress } = this
                let { claimId, claimRowVersion } = this.selectedClaim

                let response = await this.createAssignUserToClaim({
                    resellerId,
                    emailAddress: claimantEmailAddress,
                    claimId,
                    rowVersion: claimRowVersion
                })
                if (response) {
                    let userId = response.data.data.userId
                    this.fetchUserClaim({ userId })
                    this.fetchUserLoginHistoryClaim({ userId, pageNumber: 1 })
                }
            },
            handlePaginationInput(payload) {
                if (payload) {
                    this.pageNumber = payload

                    let { userId, pageNumber } = this
                    this.fetchUserLoginHistoryClaim({ userId,  pageNumber})
                }
            }
        }
    }
</script>

